import { BaseSerializer } from './base.serializer'
import { HubCourseSerializer } from './hub-course.serializer'
import { Hub, CenterProgram, Center, Program } from 'models'


export class HubProgramSerializer extends BaseSerializer<Program> {
  static initializeObject(attributes: Object): Program {
    return new Program(attributes)
  }
}

export class HubCenterSerializer extends BaseSerializer<Center> {
  static initializeObject(attributes: Object): Center {
    return new Center(attributes)
  }
}

export class HubCenterProgramSerializer extends BaseSerializer<CenterProgram> {
  static DESERIALIZERS = {
    program: HubProgramSerializer,
    center: HubCenterSerializer
  }

  static initializeObject(attributes: Object): CenterProgram {
    return new CenterProgram(attributes)
  }
}

export class HubSerializer extends BaseSerializer<Hub> {
  static SERIALIZABLE_ATTRIBUTES = [
    'id', 'name', 'address', 'hubCourses', 'excludes', 'utcOffset', 'smsConfirmation', 'hubCoursesAttributes', 'centerIds'
  ]
  static SERIALIZERS = {
    hubCourses: HubCourseSerializer
  }
  static SERIALIZE_RENAME_KEYS = {
    hubCourses: 'hubCoursesAttributes'
  }

  static DESERIALIZERS = {
    hubCourses: HubCourseSerializer,
    centerPrograms: HubCenterProgramSerializer
  }
  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): Hub {
    return new Hub(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/hub.serializer.ts